import {
  faFolderCheck,
  faFolderXmark,
  faLocationCheck,
  faMemoCircleCheck,
  faUserPolice,
} from '@fortawesome/pro-duotone-svg-icons';
import { genericResolver } from '@nittenapps/api';
import { dirtyGuard } from '@nittenapps/common';
import { NavItem } from '@nittenapps/components';

export const THEFT_ITEMS: NavItem[] = [
  {
    label: 'Robo y Recupero',
    icon: faUserPolice,
    iconSet: 'duo',
    roles: ['theft'],
    children: [
      {
        label: 'Confirmar Robo',
        icon: faFolderCheck,
        iconSet: 'duo',
        roles: ['theft'],
        routerLink: ['theft', 'confirm-theft'],
      },
      {
        label: 'Registrar Localización',
        icon: faLocationCheck,
        iconSet: 'duo',
        roles: ['theft'],
        routerLink: ['theft', 'record-location'],
      },
      {
        label: 'Registrar Recuperación',
        icon: faMemoCircleCheck,
        iconSet: 'duo',
        roles: ['theft'],
        routerLink: ['theft', 'record-recovery'],
      },
      {
        label: 'Registrar Abandono',
        icon: faFolderXmark,
        iconSet: 'duo',
        roles: ['theft'],
        routerLink: ['theft', 'record-abandonment'],
      },
    ],
  },
];

export const ROUTES = [
  {
    path: 'confirm-theft',
    loadComponent: () => import('@nittenapps/activity').then((m) => m.ActivityComponent),
    data: {
      breadcrumb: 'Confirmar Robo',
      roles: ['theft'],
    },
    children: [
      {
        path: '',
        loadComponent: () => import('./confirm-theft/list/list.component').then((m) => m.ListComponent),
      },
      {
        path: ':id',
        loadComponent: () => import('./confirm-theft/detail/detail.component').then((m) => m.DetailComponent),
        canDeactivate: [dirtyGuard],
        resolve: { model: genericResolver },
        data: {
          breadcrumb: { disabled: true, label: (data: any) => `${data.model?.number || 'Nuevo'}` },
        },
      },
    ],
  },
  {
    path: 'record-abandonment',
    loadComponent: () => import('@nittenapps/activity').then((m) => m.ActivityComponent),
    data: {
      breadcrumb: 'Registrar Abandono',
      roles: ['theft'],
    },
    children: [
      {
        path: '',
        loadComponent: () => import('./record-abandonment/list/list.component').then((m) => m.ListComponent),
      },
      {
        path: ':id',
        loadComponent: () => import('./record-abandonment/detail/detail.component').then((m) => m.DetailComponent),
        canDeactivate: [dirtyGuard],
        resolve: { model: genericResolver },
        data: {
          breadcrumb: { disabled: true, label: (data: any) => `${data.model?.number || 'Nuevo'}` },
        },
      },
    ],
  },
  {
    path: 'record-location',
    loadComponent: () => import('@nittenapps/activity').then((m) => m.ActivityComponent),
    data: {
      breadcrumb: 'Registrar Localización',
      roles: ['theft'],
    },
    children: [
      {
        path: '',
        loadComponent: () => import('./record-location/list/list.component').then((m) => m.ListComponent),
      },
      {
        path: ':id',
        loadComponent: () => import('./record-location/detail/detail.component').then((m) => m.DetailComponent),
        canDeactivate: [dirtyGuard],
        resolve: { model: genericResolver },
        data: {
          breadcrumb: { disabled: true, label: (data: any) => `${data.model?.number || 'Nuevo'}` },
        },
      },
    ],
  },
  {
    path: 'record-recovery',
    loadComponent: () => import('@nittenapps/activity').then((m) => m.ActivityComponent),
    data: {
      breadcrumb: 'Registrar Recuperación',
      roles: ['theft'],
    },
    children: [
      {
        path: '',
        loadComponent: () => import('./record-recovery/list/list.component').then((m) => m.ListComponent),
      },
      {
        path: ':id',
        loadComponent: () => import('./record-recovery/detail/detail.component').then((m) => m.DetailComponent),
        canDeactivate: [dirtyGuard],
        resolve: { model: genericResolver },
        data: {
          breadcrumb: { disabled: true, label: (data: any) => `${data.model?.number || 'Nuevo'}` },
        },
      },
    ],
  },
];
